export const isNumber = (x: any): x is number => Number.isFinite(x)

export const sumOf = (x: (number | null | undefined)[]): number =>
  x.filter(isNumber).reduce((p, c) => (p += c), 0)
